<template>
  <b-modal
    :id="id"
    size="md"
    ok-only
    ok-title="Chiudi"
    ok-variant="-transparent"
    header-bg-variant="lisaweb"
    no-close-on-esc
    no-close-on-backdrop
  >
    <template #modal-header="{ cancel }">
      <div slot="modal-title" class="modal-title">
        <span style="position: relative; top: -2px"
          ><b-icon icon="files"></b-icon
        ></span>
        <span>Duplica Template {{ typeLabel }}</span>
      </div>
      <button
        type="button"
        class="close"
        title="Chiudi"
        data-dismiss="modal"
        @click="cancel()"
      >
        <base-icon name="close" width="14" height="14" />
      </button>
    </template>
    <div class="mx-1">
      <b-overlay center :show="isLoading" rounded="sm">
        <div>
          <validation-observer ref="observer" v-slot="{ invalid, handleSubmit }">
            <b-form @submit.prevent="handleSubmit(onConfirm)">
              <b-row>
                <div class="mt-3 form-group col-md-12">
                  <base-input
                    vid="title"
                    name="title"
                    label="Titolo del nuovo template"
                    v-model="form.title"
                    placeholder="Inserisci un titolo"
                    :rules="{ required: true }"
                  />
                </div>
              </b-row>
              <b-row>
                <b-col align="right">
                  <b-button
                    @click="handleSubmit(onConfirm)"
                    type="button"
                    :disabled="invalid"
                    variant="lisaweb"
                    size="sm"
                    class="mt-2 float-right"
                  >
                    Duplica
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </div>
        <template #overlay>
          <div class="text-center">
            <div class="custom-loader"></div>
            <p class="loading-text">Operazione in corso...</p>
          </div>
        </template>
      </b-overlay>
    </div>
  </b-modal>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/form/BaseInput";
import { RepositoryFactory } from "@/repositories/lisacomunica/RepositoryFactory";

export default {
  name: "duplicateLisacomunicaTemplateModal",
  components: {
    BaseIcon,
    BaseInput,
  },
  props: {
    id: {
      type: String,
      default: "duplicateLisacomunicaTemplateModal",
    },
    repository: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    typeLabel: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
      form: {
        title: null,
      },
    };
  },
  watch: {
    item: {
      immediate: true,
      handler(newVal) {
        this.form.title = newVal && newVal.title ? newVal.title : null;
      },
    },
  },
  methods: {
    buildPayload(content) {
      switch (this.repository) {
        case "email":
          return {
            title: this.form.title,
            type: content.type,
            subject: content.subject,
            email: content.text ?? content.email,
            text: content.text ?? content.email,
          };
        case "sms":
          return {
            title: this.form.title,
            type: content.type,
            text_content: content.text_content,
          };
        case "pdf":
          return {
            title: this.form.title,
            type: content.type,
            margin_left: content.margin_left,
            margin_right: content.margin_right,
            margin_top: content.margin_top,
            margin_bottom: content.margin_bottom,
            css: content.css,
            header: content.header,
            body: content.body,
            ads: content.ads,
            footer: content.footer,
          };
        default:
          return { title: this.form.title };
      }
    },
    onConfirm() {
      if (!this.item || !this.item.id) {
        this.$showSnackbar({
          preset: "error",
          text: `Impossibile duplicare il template: identificativo mancante.`,
        });
        return;
      }
      this.isLoading = true;
      const Repo = RepositoryFactory.get(this.repository);
      Repo.show(this.item.id)
        .then((response) => Repo.store(this.buildPayload(response.data.content)))
        .then(() => {
          this.$bvModal.hide(this.id);
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Template ${this.typeLabel} duplicato`,
          });
          this.$emit("duplicated");
        })
        .catch((error) => {
          let errMsg =
            error?.response?.data?.message || this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      if (modalId !== this.id) return;
      this.form.title = null;
    });
  },
};
</script>
